import React from "react";
import { Box, Typography, Skeleton } from "@mui/material";

import { StatCardProps } from "../../types";
import { formatNumber } from "../../utils/format";

import "./statCard.css";

const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  icon,
  bgColor,
  color,
  loading = false,
  trend,
}) => {
  const isNegative = trend?.startsWith("-");

  return (
    <Box className="stat-card">
      {/* ICON */}
      <Box
        className="stat-icon"
        style={{
          backgroundColor: bgColor,
          color: color,
        }}
      >
        {icon}
      </Box>

      {/* CONTENT */}
      <Box className="stat-content">
        {/* VALUE */}
        {loading ? (
          <Skeleton width={60} height={30} />
        ) : (
          <Typography className="stat-value">
            {formatNumber(value)}
          </Typography>
        )}

        {/* TITLE */}
        {loading ? (
          <Skeleton width={80} height={20} />
        ) : (
          <Typography className="stat-title">
            {title}
          </Typography>
        )}

        {/* TREND */}
        {!loading && trend && (
          <Typography
            className={`stat-trend ${
              isNegative ? "down" : "up"
            }`}
          >
            {trend}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default StatCard;